<template>
<div class="auth flex flex-wrap min-h-screen">
    <alert v-model="notify.show" :errorType="notify.type" :message="notify.message" />
    <router-link to="/">
        <img class="inline h-24 p-4 fixed" :src="require('../../../assets/edc-logo-dark.png')" alt="" />
    </router-link>
    <div style="background: linear-gradient(89.81deg, #111111 0.05%, rgba(46, 58, 110, 0.55) 41.25%), url('https://res.cloudinary.com/dldd8ucby/image/upload/v1590173622/WhatsApp_Image_2020-05-22_at_7.01.56_PM.jpg') no-repeat center center ; background-size: cover;" class="w-full md:w-1/2 md:flex hidden items-center justify-center text-center text-black p-6">
        <!-- <div class="mx-4 md:mx-16">
        <span class="welcome-back block">Welcome Back</span>
        <span class="welcome-mini block">Let's get you in the game</span>
      </div> -->
    </div>
    <div class="w-full md:w-1/2 text-white  flex items-center justify-center text-center">
        <div class="form w-full md:w-4/5 mx-4 md:mx-auto">
            <p class="purple-bg mx-auto uppercase py-3">Sign In</p>
            <p class="main my-2">Log In to your account</p>
            <p class="mini">Build skills for today, tomorrow, and beyond.</p>
            <p class="mini">Education to future-proof your career.</p>
            <div class="mx-4 md:mx-12">
                <div class="my-6">
                    <input v-model="data.email" class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="email" placeholder="Email" />
                </div>

                <div class="my-6">
                    <input class="shadow appearance-none border rounded w-full py-4 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="username" type="password" placeholder="Password" v-model="data.password" />
                </div>

                <p class="mini">
                    By clicking Sign In, you agree to our Terms of Use and our Privacy
                    Policy
                </p>

                <button @click.prevent="submit" class="purple-bg text-white w-full py-2 px-4 mt-4 mb-2 rounded uppercase">
                    Login
                </button>
            </div>
            <div class="flex flex-wrap justify-center mb-4">
                <p class=" mt-4 forgot-password">
                    <router-link to="/auth/forgot-password">Forgot Password?</router-link>
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import axios from "axios";
export default {
    data() {
        return {
            data: {},
            loading: false,
            notify: {
                type: null,
                show: false,
                message: "",
            },
        };
    },
    components: {
        Alert: () => import("@/components/admin/alert"),
    },
    mounted() {
        this.updateLoader(false);
    },
    computed: {
        ...mapGetters(["getUser"]),
    },

    methods: {
        ...mapActions(["login"]),
        ...mapMutations(["updateLoader"]),
        async submit() {
            if (!this.data.email) {
                this.handleNotify({
                    type: "error",
                    message: "You need to enter your Email",
                });
                return;
            }
            if (!this.data.password) {
                this.handleNotify({
                    type: "error",
                    message: "You need to enter your Password",
                });
                return;
            }
            this.updateLoader(true);
            let res = await this.login(this.data);
            console.log("Login");
            console.log(res)
            this.updateLoader(false);
            if (res == true) {
                this.loading = false;
                if (this.getUser.role === "Super Admin") {
                    this.$router.push("/admin");
                }
                if (this.getUser.role === "Tenant" || this.getUser.role === "Tenant Supervisor") {
                    this.$router.push("/tenant/my-courses");
                }
            } else {
                this.loading = false;
                this.handleNotify({
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title :
                        "An error occured",
                });
            }
        },
        handleNotify(payload) {
            this.notify.show = true;
            this.notify.type = payload.type;
            this.notify.message = payload.message;
        },
    },

};
</script>

<style scoped>
.auth {
    background: #102767;
}

.form {
    background: #2e3a6e;
}

.purple-bg {
    background: #5e6da8;
    color: white;
}

.main {
    font-size: 24px;
    line-height: 48px;
}

.mini {
    font-size: 14px;
    line-height: 22px;
    margin: 5px auto;
}
</style>
